"use client";

// context/DarkModeContext.js
import { createContext, useContext, useState, useEffect } from 'react';

// Create the context
const DarkModeContext = createContext();

// Create a custom hook to use the dark mode context
export const useDarkMode = () => {
    return useContext(DarkModeContext);
};

// Create a provider component
export const DarkModeProvider = ({ children }) => {
const [isDarkMode, setIsDarkMode] = useState(false);

useEffect(() => {
    const checkDarkMode = () => {
    setIsDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches);
    };

    checkDarkMode();

    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    mediaQuery.addEventListener('change', checkDarkMode);

    return () => {
    mediaQuery.removeEventListener('change', checkDarkMode);
    };
}, []);


return (
    <DarkModeContext.Provider value={isDarkMode}>
    {children}
    </DarkModeContext.Provider>
);
};
